import React, { lazy, useState, useEffect, Suspense } from 'react'
import { Layout } from 'components'
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Container
} from 'reactstrap'
import { useParams, useLocation, useNavigate } from 'react-router-dom'

const PartnerMemberTree = lazy(() => import('./PartnerMemberTree'))

function PartnerMember (props) {
  const { search, pathname } = useLocation()
  const location = useLocation()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('parterMemberTree')

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
      // navigate(`${pathname}?tab=${tab}`)
    }
  }

  useEffect(() => {
    const tabParam = new URLSearchParams(search).get('tab')
    const initialTab = tabParam || 'parterMemberTree'
    setActiveTab(initialTab)
  }, [location])
  return (
    <Layout>
      <Container className='page-content' fluid style={{ padding: 30 }}>
        <Row>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={activeTab === 'parterMemberTree' ? 'sub-link active' : ''}
                onClick={() => toggleTab('parterMemberTree')}
              >
                파트너 회원 트리
              </NavLink>
            </NavItem>
          </Nav>
        </Row>
        <Row>
          <TabContent className='partner-tab-content' activeTab={activeTab}>
            {activeTab === 'parterMemberTree' && (
              <TabPane tabId='parterMemberTree'>
                <Suspense fallback={<div>Loading...</div>}>
                  <PartnerMemberTree />
                </Suspense>
              </TabPane>
            )}
          </TabContent>
        </Row>
      </Container>
    </Layout>
  )
}

export default PartnerMember
